import { Link, useParams } from 'react-router-dom';
import { useContent } from '../context/ContentContext';
import { LoadingState } from '../components/LoadingState';
import { ErrorState } from '../components/ErrorState';
import { findSpecificIssue, getCategoryLabel, getTopicPath } from '../lib/contentUtils';

export function SpecificIssuePage() {
  const { hlSlug, specificSlug } = useParams<{ hlSlug: string; specificSlug: string }>();
  const { data, loading, error, reload } = useContent();

  if (loading) return <LoadingState />;
  if (error || !data) return <ErrorState message={error ?? 'No data'} onRetry={reload} />;

  const resolved =
    hlSlug && specificSlug ? findSpecificIssue(data, hlSlug, specificSlug) : undefined;

  if (!resolved) {
    return (
      <div className="page">
        <ErrorState message="Subtopic not found." />
      </div>
    );
  }

  const { highLevel, specific } = resolved;
  const context = { highLevelSlug: highLevel.slug, specificSlug: specific.slug };

  return (
    <div className="page specific-issue-page">
      <nav className="breadcrumb" aria-label="Breadcrumb">
        <Link to="/explore">Explore</Link>
        <span aria-hidden> / </span>
        <Link to={`/issues/${highLevel.slug}`}>{highLevel.title}</Link>
        <span aria-hidden> / </span>
        <span>{specific.title}</span>
      </nav>

      <header className="page-header">
        <p className="page-eyebrow">{highLevel.title}</p>
        <h1>{specific.title}</h1>
        <p>{specific.description}</p>
        <p className="section-count">{specific.itemCount} entries in this subtopic</p>
      </header>

      <ol className="issue-list">
        {specific.detailItems.map((item) => (
          <li key={item.id}>
            <Link
              to={getTopicPath(data, item, context)}
              className="issue-list-item"
            >
              <span className="issue-list-body">
                <span className="issue-title">{item.title}</span>
                <span className="issue-meta">{getCategoryLabel(item.category)}</span>
              </span>
              <span className="issue-arrow" aria-hidden>→</span>
            </Link>
          </li>
        ))}
      </ol>

      {specific.detailItems[0] && (
        <div className="section-start-cta">
          <Link
            to={getTopicPath(data, specific.detailItems[0], context)}
            className="btn btn-primary"
          >
            Begin with first entry
          </Link>
        </div>
      )}
    </div>
  );
}
